import React, { useContext, useEffect, useState } from 'react'
import { Select, Input, DatePicker, TimePicker, Modal, message } from 'antd';
import * as yup from "yup";
import axios from "../../../../../../Lib/axios";
import workOrderStatus from '../../../../../Common/workOrderStatus.json';
import chevronLeft from '../../../../../../Assets/images/chevron-left.png';
import addGreenCircle from '../../../../../../Assets/images/add-circle-outline-green.svg';
import { map } from 'lodash';
import moment from 'moment-timezone';
import { formatToCurrency } from "../../../../../../Tools/formatToCurrency";

import { CloseOutlined } from '@ant-design/icons';
const { Option } = Select;
const PageContext = React.createContext();

export default function ServiceDetails(props) {
  const [state, setState] = useState({ cleaningAreas: [], addons: [], errors: {} });
  const [price, setPrice] = useState({});
  
  return (
    <PageContext.Provider value={{
        state,
        setState,
        price,
        setPrice,
        clearState: () => { setState({ cleaningAreas: [], addons: [], errors: {} }) },
        ...props
      }}>
      <ServiceDetails_ />
    </PageContext.Provider>
  )
}

function ServiceDetails_() {
  const ctx = useContext(PageContext);
  const { state, setState, currentRecord, transection_type, setPrice, price, goback = () => { }, clearState } = ctx;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [field_office__uuid, setField_office__uuid] = useState('');
  const {
    date,
    time,
    lastClean,
    cleaningAreas,
    rows,
    is_initial_cleaning,
    otherCleaning,
    status,
    selectedTechnician,
    lockdate,
  } = state;

  useEffect(() => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    
    const redirectToWorkOrder =  params.redirect_to_work_order;

    if (redirectToWorkOrder)
    {
      axios.get(`/service-ftech/${currentRecord?.uuid}`)
        .then(response => {
          let status = '';
          if (response?.data?.status === 'cancelled' && !response?.data?.bill_for_cancelization) {
            status = 'cancelled_non_billable'
          } else if (response?.data?.status === 'cancelled' && response?.data?.bill_for_cancelization && !response?.data?.is_auto_invoice_genrated) {
            status = 'cancelled_billable'
          } else if (response?.data?.status === 'cancelled' && response?.data?.is_auto_invoice_genrated) {
            status = 'Cancelled Billed'
          } else {
            status = response?.data?.status;
          }

          setState(s => ({
            ...s,
            original_status: status,
            status: status,
            selectedTechnician: response?.data?.technician_uuid,
            date: response?.data?.date,
            time: (response?.data?.status === "forecast") ? null : (response?.data?.time || null),
            disposal_location: response?.data?.disposal_location,
            cleaning_notes: response?.data?.cleaning_notes,
            security_code: response?.data?.security_code,
            addons: response?.data?.add_on_uuid,
            is_initial_cleaning: response?.data?.is_initial_cleaning || false,
            lastClean: response?.data?.last_cleaned || "",
            rows: response?.data?.miscallaneous_services || [],
            lockdate: response?.data?.is_lock_date || false,
            field_office_uuid: response?.data?.service_order?.field_office__uuid,
            frequency: response?.data?.service_order?.frequency,
            property_type: response?.data?.service_order?.property_type,
            pet_count: response?.data?.service_order?.pet_count,
            calculated_price: response?.data?.calculated_price,
          }));

          setField_office__uuid(field_office__uuid);
        });
    }
    else if (transection_type === "Update" || transection_type === "View") {
      axios.get(`/service-ftech/${currentRecord?.uuid}`)
        .then(response => {
          let status = '';
          if (response?.data?.status === 'cancelled' && !response?.data?.bill_for_cancelization) {
            status = 'cancelled_non_billable'
          } else if (response?.data?.status === 'cancelled' && response?.data?.bill_for_cancelization && !response?.data?.is_auto_invoice_genrated) {
            status = 'cancelled_billable'
          } else if (response?.data?.status === 'cancelled' && response?.data?.is_auto_invoice_genrated) {
            status = 'Cancelled Billed'
          } else {
            status = response?.data?.status;
          }
          setState(s => ({
            ...s,
            status: status,
            original_status: status,
            selectedTechnician: response?.data?.technician_uuid,
            date: response?.data?.date,
            time: (response?.data?.status === "forecast") ? null : (response?.data?.time || null),
            disposal_location: response?.data?.disposal_location,
            cleaning_notes: response?.data?.cleaning_notes,
            security_code: response?.data?.security_code,
            addons: response?.data?.add_on_uuid,
            is_initial_cleaning: response?.data?.is_initial_cleaning || false,
            lastClean: response?.data?.last_cleaned || "",
            rows: response?.data?.miscallaneous_services || [],
            lockdate: response?.data?.is_lock_date || false,
            field_office_uuid: response?.data?.service_order?.field_office__uuid,
            calculated_price: response?.data?.calculated_price,
          }))
          setField_office__uuid(field_office__uuid);
        })
        .catch(error => {
          console.error(error)
        })
    } else if (transection_type === "Create") {
      let addon = [];
      if (currentRecord?.service_add_ons && currentRecord?.service_add_ons.length > 0) {
        map(currentRecord?.service_add_ons, (item) => {
          addon.push(item?.add_on_uuid)
        });
      }
      
      setState(s => ({
        ...s,
        status: "forecast",
        selectedTechnician: "",
        date: "", //moment().format("MMM DD,YYYY"),
        time: "", //moment().format("HH:MM A"),
        disposal_location: currentRecord?.disposal_location,
        cleaning_notes: currentRecord?.cleaning_notes,
        security_code: currentRecord?.security_code,
        addons: addon,
        is_initial_cleaning: false,
        lastClean: "",
        rows: currentRecord?.miscallaneous_services,
        lockdate: false,
        field_office_uuid: currentRecord?.service_order?.field_office__uuid,
      }));

      setField_office__uuid(field_office__uuid);
    }
  }, [])

  useEffect(() => {
    (async () => {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      
      const redirectToWorkOrder =  params.redirect_to_work_order;
      let data;

      const { serviceOrder } = ctx;
  
      if ((transection_type === "Update" || transection_type === "View"))
      {
        if (redirectToWorkOrder)
        {
          if(state.status === "Cancelled")
          {
            data = {
              "field_office_uuid": state.field_office_uuid,
              "frequency": state.calculated_price.frequency,
              "property_type": state.calculated_price.property_type,
              "pet_count": state.calculated_price.pet_count,
            }
          }
          else
          {
            data = {
              "field_office_uuid": state.field_office_uuid,
              "frequency": state.frequency,
              "property_type": state.property_type,
              "pet_count": state.pet_count,
            }
          }
  
          setField_office__uuid(state.field_office__uuid);
        }
        else if(state.status === "cancelled") {
          data = {
            "field_office_uuid": currentRecord?.service_order?.field_office__uuid,
            "frequency": state?.calculated_price?.frequency,
            "property_type": state?.calculated_price?.property_type,
            "pet_count": state?.calculated_price?.pet_count,
            "service_order_base_price": state?.calculated_price?.service_order_base_price
          }
          setField_office__uuid(currentRecord?.service_order?.field_office__uuid);
        }
        else
        {
          data = {
            "field_office_uuid": currentRecord?.service_order?.field_office__uuid,
            "frequency": currentRecord?.service_order?.frequency,
            "property_type": currentRecord?.service_order?.property_type,
            "pet_count": currentRecord?.service_order?.pet_count,
            //"charge_initial_clean": state.is_initial_cleaning
          }
          setField_office__uuid(currentRecord?.service_order?.field_office__uuid);
        }
  
        if (state?.is_initial_cleaning && state?.lastClean && state?.lastClean !== "") {
          data['is_initial_cleaning'] = state?.is_initial_cleaning;
          data['last_cleaned'] = state?.lastClean;
        }
        if (state?.addons && state?.addons?.length > 0) {
          data['add_ons'] = state?.addons;
        }
        if (state?.cleaningAreas && state?.cleaningAreas?.length > 0) {
          data['areas_to_clean'] = state?.cleaningAreas;
        }
        if (state?.rows && state?.rows?.length > 0) {
          data['miscallaneous_services'] = state?.rows;
        }

        if(state?.calculated_price)
        {
          data['service_order_base_price'] = state?.calculated_price?.service_base_price;
        }
  
        if(state.status && state.original_status !== "complete" && state.calculated_price)
        {
          const res = await axios.post(`/service-ftech/work_order_pricing_calculator/`, data);
          setPrice(res?.data);
        }
        else
        {
          setPrice(state.calculated_price);
        }
      } else if (transection_type === "Create") {
        let data = {
          "field_office_uuid": currentRecord?.field_office_uuid,
          "frequency": currentRecord?.frequency,
          "property_type": currentRecord?.property_type,
          "pet_count": currentRecord?.pet_count || null,
          "charge_initial_clean": state.is_initial_cleaning
        };
        setField_office__uuid(currentRecord?.field_office__uuid)
        if (state?.is_initial_cleaning && state?.lastClean && state?.lastClean !== "") {
          data['is_initial_cleaning'] = state?.is_initial_cleaning;
          data['last_cleaned'] = state?.lastClean;
        }
        if (state?.addons && state?.addons?.length > 0) {
          data['add_ons'] = state?.addons;
        }
        if (state?.cleaningAreas && state?.cleaningAreas?.length > 0) {
          data['areas_to_clean'] = state?.cleaningAreas;
        }
        if (state?.rows && state?.rows?.length > 0) {
          data['miscallaneous_services'] = state?.rows;
        }
        if(serviceOrder)
        {
          data['service_order_base_price'] = serviceOrder?.calculated_price?.service_base_price;
        }
        
        await axios.post(`/service-ftech/work_order_pricing_calculator/`, data).then(res => {
          setPrice(res?.data);
        });
      }
    }) ()
  }, [state]);

  const createWorkOrder = () => {
    const idx = cleaningAreas.indexOf("");
    if (idx > -1) {
      cleaningAreas[idx] = otherCleaning;
    }
    let data = {
      "status": (state?.status === 'cancelled_non_billable' || state?.status === 'cancelled_billable') ? 'cancelled' : state?.status,
      "miscallaneous_services": state?.rows,
      "add_on_uuid": state?.addons,
      "area_to_clean": state?.cleaningAreas,
      "is_initial_cleaning": state?.is_initial_cleaning,
      "last_cleaned": state?.lastClean,
      "date": state?.date ? moment(state?.date).format("YYYY-MM-DD") : null,
      "disposal_location": state?.disposal_location,
      "cleaning_notes": state?.cleaning_notes,
      "security_code": state?.security_code,
      "service_order_uuid": currentRecord?.uuid,
      "is_lock_date": state.lockdate,
    }
    // check technician
    if (state?.selectedTechnician) {
      data['technician_uuid'] = state?.selectedTechnician;
    }
    // check time
    if (state?.time) {
      data['time'] = moment(state?.time).format("HH:mm:ss") === "Invalid date" ? state?.time : moment(state?.time).format("HH:mm:ss");
    }
    /**
     * AUTHOR: Ritesh Solanki
     * Modify code as when we select Cancelled - Billable then it shows cancelled - Billed in tables
     * <DP-4078></DP-4078>
     */
    if (state?.status === 'complete_and_billed') {
      data['is_auto_invoice_genrated'] = true;
    }
    if (state?.status === 'complete_and_not_billed') {
      data['is_auto_invoice_genrated'] = false;
    }
    if (state?.status === 'cancelled_non_billable') {
      data['bill_for_cancelization'] = false;
    }
    if (state?.status === 'cancelled_billable') {
      data['bill_for_cancelization'] = true;
      data['is_auto_invoice_genrated'] = false;
    }

    axios.post(`/service-ftech/`, data).then((response) => {
      message.success(`Work order ${response?.data?.work_order_number || ""} created.`, 10);
      setTimeout(() => {
        goback();
      }, 1000);
    }).catch(error => {
      console.log(error);
      message.error(`Error occurred while updating Work order.`, 30);
    });
  }

  const updateWorkOrder = () => {
    const idx = cleaningAreas.indexOf("");

    if (idx > -1) {
      cleaningAreas[idx] = otherCleaning;
    }

    let data = {
      "status": (state?.status === 'cancelled_non_billable' || state?.status === 'cancelled_billable') ? 'cancelled' : state?.status,
      "miscallaneous_services": state?.rows,
      "add_on_uuid": state?.addons,
      "area_to_clean": state?.cleaningAreas,
      "is_initial_cleaning": state?.is_initial_cleaning,
      "last_cleaned": state?.lastClean,
      "date": state?.date,
      "disposal_location": state?.disposal_location,
      "cleaning_notes": state?.cleaning_notes,
      "security_code": state?.security_code,
      "is_lock_date": state?.lockdate,
      "field_office_uuid": currentRecord?.service_order?.field_office__uuid,
    }

    // check technician
    if (state?.selectedTechnician) {
      data['technician_uuid'] = state?.selectedTechnician;
    }
    // check time
    if (state?.time) {
      data['time'] = moment(state?.time).format("HH:mm:ss") === "Invalid date" ? state?.time : moment(state?.time).format("HH:mm:ss");
    }

    if (state?.status === 'complete_and_billed') {
      data['is_auto_invoice_genrated'] = true;
    }
    if (state?.status === 'complete_and_not_billed') {
      data['is_auto_invoice_genrated'] = false;
    }
    if (state?.status === 'cancelled_non_billable') {
      data['bill_for_cancelization'] = false;
    }
    if (state?.status === 'cancelled_billable') {
      data['bill_for_cancelization'] = true;
      data['is_auto_invoice_genrated'] = false;
    }

    axios.patch(`/service-ftech/${currentRecord?.uuid}/`, data).then((response) => {
      message.success(`Work order ${response?.data?.work_order_number || ""} updated.`, 10);
      setTimeout(() => {
        goback();
      }, 1000);
    }).catch(error => {
      console.log(error);
      message.error(`Error occurred while updating Work order.`, 100);
    });
  }

  const workorder_status = [
    "tentative",
    "scheduled",
    "technician_assigned",
    "technician_en_route",
    "in_progress",
    "complete"
  ]

  const time_status = [
    "tentative",
    "scheduled",
    "technician_assigned",
    "technician_en_route",
    "in_progress",
    "complete",
    "incomplete"
  ]

  const validate = () => {
    let selectedTime = moment(time).format("hh:mm a") === "Invalid date" ? time : moment(time).format("hh:mm a");
    let selectedDate = status === 'forecast' ? date : `${date} ${selectedTime}`;
    let isPastDate = false;
    let isFutureDate = false;
    if (status === 'forecast') {
      isPastDate = moment(date, "YYYY/MM/DD").isBefore(moment(new Date()).format("YYYY/MM/DD"));
      console.warn('forecast - isPastDate', isPastDate, 'scheduled', selectedDate)
    }
    // if (status === 'scheduled') {
    //   isPastDate = moment(selectedDate).isBefore(moment(new Date()).format("YYYY/MM/DD hh:mm a"));
    //   console.warn('scheduled- isPastDate', isPastDate, 'scheduled', selectedDate)
    // }
    if (status === 'complete' || status === 'incomplete' || status==='cancelled_billable') {
      isFutureDate = !moment(date, "YYYY/MM/DD").isBefore(moment());
    }
    const schema = yup.object().shape({
      date: yup.string().required('Select date.'),
      status: yup.string().required('Please select valid status.'),
      time: time_status.indexOf(status) > -1 && !state?.time ? yup.string().required('Select time.') : null,
      time_past: isPastDate && (time || status === 'forecast') ? yup.string().required('Work orders in this status cannot have a date/time in the past.') : null,
      time_future: isFutureDate ? yup.string().required('Work orders in this status cannot have a date/time in the future.') : null,
      lastClean: is_initial_cleaning ? yup.string().required('Please select when the property was last cleaned.') : null,
      cleaningAreas: cleaningAreas.length === 0 ? yup.string().nullable().required('Please select at least one cleaning area.') : null,
      otherCleaning: cleaningAreas.indexOf("") > -1 && (otherCleaning === undefined || otherCleaning === '') ? yup.string().required('Please enter the Other cleaning area.') : null,
      technician: workorder_status.indexOf(status) > -1 && !selectedTechnician ? yup.string().required('Please select assigned technician.') : null,
      rows: yup.array(yup.object({
        mis_type:yup.string().oneOf(["product", "service"]).required('Select one'),
        item: yup.string().required('Enter item'),
        price: yup.number().required('Enter price').typeError('Enter valid price'),
      })),
    });
    const data = { date: date || '', time, lastClean, rows, status };
    schema.validate(data, { abortEarly: false }).then(() => {
      setState(s => ({ ...s, errors: {} }));
      if (transection_type === "Update") {
        updateWorkOrder();
      } else if (transection_type === "Create") {
        createWorkOrder();
      }
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => { err_data[item.path] = item.message });
      setState(s => ({ ...s, errors: err_data }));
    })
  }

  return (
    <div className="block-row p-0">
      <div className="filter_wrapper">
        <span
          role="button"
          className="backbtn"
          onClick={(e) => {
            clearState()
            goback()
          }}
        >
          <img src={chevronLeft} alt="" /> Back to all services
        </span>
      </div>
      <div className="container" style={{
        backgroundColor: "white"
      }}>
        <div className="container" style={{ display: "flex" }}>
          <div style={{ minWidth: 380, width: 380, padding: "2em" }}>
            <WorkOrderDetails field_office__uuid={field_office__uuid} />
          </div>
          <div style={{ padding: "2em", borderLeft: '1px solid rgb(28, 29, 33, 0.1)' }}>
            <h3>
              Base Cleaning Requirements
            </h3>
            <LastClean />
            <hr className="my-20" />
            <h3 className="mb-10">
              Service Details
            </h3>
            <small className="mb-20 d-block">Any changes made here will only affect this particular work order. For changes to the series, please see the service order.</small>
            <div className="mb-20">
              <CleaningAreas />
            </div>
            <div className="mb-20">
              <AddOns />
            </div>
            <div className="mb-20">
              <Miscellanious />
            </div>

            <div className="mb-20">
              <h4 className="mb-5">Disposal Area</h4>
              <p className="fs-13 mb-5">
                Our standard policy is to double bag the scooped waste, tie it securly to contain odor, and place it in your garbage can. Please let us know where the garbage can is located or if you'd like the bagged waste placed elsewhere.
              </p>
              <Input
                // type="text" 
                disabled={transection_type === "View"}
                value={state.disposal_location}
                placeholder="Scooped waste disposal area"
                onChange={(e) => {
                  setState(s => ({ ...s, disposal_location: e.target.value }))
                }}
              />
            </div>
            <div className="mb-60">
              <h4 className="mb-5">Cleaning Notes</h4>
              <p className="fs-13 mb-5">
                Any special instructions about your property that we should know? (e.g. gate code, yard access etc.)
              </p>
              <div className="field-group">
                <Input
                  disabled={transection_type === 'View'}
                  value={state.cleaning_notes}
                  placeholder="Additional cleaning notes"
                  onChange={(e) => {
                    setState(s => ({ ...s, cleaning_notes: e.target.value }))
                  }}
                />
              </div>
              <div className="field-group">
                <label>Security Code</label>
                <Input
                  disabled={transection_type === 'View'}
                  value={state.security_code}
                  placeholder="Security code"
                  onChange={(e) => {
                    setState(s => ({ ...s, security_code: e.target.value }))
                  }}
                />
              </div>
            </div>
          </div>
          <div style={{ backgroundColor: '#e4eaed', minWidth: 425, padding: "2em" }}>
            <WorkOrderSummary status={status} />
          </div>
        </div>
      </div>
      <div className="fix-btn-grp">
        <button
          className="btn btn-white"
          onClick={() => setIsModalVisible(true)}>
            Exit Creator
        </button>
        {transection_type === "Update" &&
          <button className={`btn btn-warning`} onClick={() => validate()}>Update Work Order</button>
        }
        {transection_type === "Create" &&
          <button className={`btn btn-warning`} onClick={() => validate()}>Create Work Order</button>
        }
        <Modal
          title="Exit Creator?"
          visible={isModalVisible}
          okText={"Exit Creator"}
          cancelText={"Cancel"}
          onOk={() => {
            clearState()
            goback()
          }}
          onCancel={() => {
            setIsModalVisible(false);
          }}
          className="delete_user_modal"
          width={400}
        >
          <h3>Exit Creator?</h3>
          <p>Are you sure you would like to exit Creating a Work Order ?</p>
          <p>All progress will be lost</p>
        </Modal>
      </div>
    </div>
  )
}

function WorkOrderDetails(props) {
  const ctx = useContext(PageContext);
  const { state, setState, transection_type } = ctx;
  const [technicians, setTechnicians] = useState([]);
  const { errors } = state;

  useEffect(() => {
    axios
      .get(`/ftech/field-technicians/`, {params: {field_office__uuid: props.field_office__uuid}})
      .then(response => {
        setTechnicians(response?.data?.results)
      })
      .catch(error => {
        console.log(error)
      })
  }, [props])

  const updateTechnician = (selectedTechnician) => {
    setState(s => ({ ...s, selectedTechnician }))
  }

  const updateIsLockdate = (lockdate) => {
    setState(s => ({ ...s, lockdate: lockdate }));
  }

  return (
    <>
      <div className="flex">
        <h4> Work Order Details </h4>
      </div>
      <div className="field-group">
        <label>status<sup>*</sup></label>
        <Select
          value={state?.status}
          disabled={transection_type === 'View'}
          onChange={(e) => {
            // message.destroy();
            if (e === 'complete') {
              setState(s => ({
                ...s,
                status: e,
                time: moment("12:00 AM", ["h:mm A"])
              }))
            } else {
              setState(s => ({
                ...s,
                status: e,
                time: '',
                selectedTechnician: e === "forecast" ? "" : state?.selectedTechnician
              }))
            }
          }}
        >
          {map(workOrderStatus.WorkOrderStatus, (item, index) => {
            if (index > 0) {
              return (
                <Option key={index} value={item.value}>{item.label}</Option>
              )
            }
          })}
        </Select>
        {errors?.['status'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['status']}</label> : ''}
      </div>
      <div className="field-group">
        <label>Assigned Technician</label>
        <Select
          showSearch
          placeholder="Not assigned"
          optionFilterProp="children"
          onChange={(e) => {
            updateTechnician(e)
          }}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          value={state?.selectedTechnician || undefined}
          disabled={state?.status === "forecast" || transection_type === 'View'}
        >
          {
            technicians?.map((technician, index) => {
              return <Option key={index} value={technician.uuid}>{`${technician?.user?.first_name} ${technician?.user?.last_name}`}</Option>
            })
          }

        </Select>
        {errors?.['technician'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['technician']}</label> : ''}
      </div>
      <div style={{ display: 'flex' }}>
        <div className="field-group" style={{ width: "50%", paddingRight: 5 }}>
          <label>Work Order Date<sup>*</sup></label>
          <DatePicker
            style={{ 'width': '100%' }}
            // disabled={state?.status?.includes("complete") || transection_type === 'View'}
            disabled={transection_type === 'View'}
            // disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
            format="MMM DD,YYYY"
            suffixIcon={<i className="las la-calendar"></i>}
            allowClear={true}
            value={state.date ? moment(state.date) : null}
            onChange={(e) => {
              if (e) {
                setState(s => ({ ...s, date: moment(e).format("YYYY-MM-DD") }))
              } else {
                setState(s => ({ ...s, date: null }))
              }
            }}
          />
          {errors?.['date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['date']}</label> : ''}
        </div>
        <div className="field-group" style={{ width: "50%", paddingLeft: 5 }}>
          <label>Time {(state?.status !== 'forecast' || state?.status === 'cancelled') && <sup>*</sup>}</label>
          <TimePicker
            className="swhite"
            placeholder={'--:-- AM/PM'}
            value={state?.time ? moment(state?.time, "hh:mm") : undefined}
            onChange={(e) => {
              setState(s => ({ ...s, time: e }))
            }}
            allowClear={["forecast", "canceled"].includes(state?.status)}
            // minuteStep={1}
            // allowClear={true}
            format={'h:mm A'}
            disabled={state?.status === "forecast" || transection_type === "View"}
          />
          {errors?.['time'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['time']}</label> : ''}
        </div>
      </div>
      <div className="fitem-check">
        <input
          type="checkbox"
          className="fitem-ck-input"
          id="lockdate"
          name="lockdate"
          checked={state.lockdate}
          onChange={(e) => updateIsLockdate(e.target.checked)}
          value={state.lockdate}
          disabled={transection_type === "View"}
        />
        <label htmlFor="lockdate" className="fitem-ck-txt">Lock date</label>
      </div>
      {errors?.['time_past'] ? <label className="new_err_msg align-items-start lh-20"><i className="las la-info-circle" />{errors?.['time_past']}</label> : ''}
      {errors?.['time_future'] ? <label className="new_err_msg align-items-start lh-20"><i className="las la-info-circle" />{errors?.['time_future']}</label> : ''}
    </>
  )
}

function LastClean() {
  const ctx = useContext(PageContext);
  const { state, setState, transection_type } = ctx;
  const { errors } = state;

  function selectLastClean(value) {
    setState(s => ({ ...s, lastClean: value }));
  }

  const initialCleanChecked = (e) => {
    if (e.target.checked) {
      setState(s => ({ ...s, is_initial_cleaning: true }));
    } else {
      setState(s => ({ ...s, is_initial_cleaning: false }));
    }

    if (!e.target.checked) {
      setState(s => ({ ...s, lastClean: "" }));
    }
  }

  return (
    <>
      <div className="fitem-check mt-10">
        <input
          type="checkbox"
          className="fitem-ck-input"
          id="is_initial_cleaning"
          name="is_initial_cleaning"
          checked={state.is_initial_cleaning}
          onChange={(e) => initialCleanChecked(e)}
          value={state.is_initial_cleaning}
          disabled={transection_type === 'View'}
        />
        <label htmlFor="is_initial_cleaning" className="fitem-ck-txt">Initial clean service</label>
      </div>
      {state.is_initial_cleaning && <React.Fragment>
        <h4 className="mb-5 mt-20">Last Clean <sup>*</sup></h4>
        <div style={{ display: 'flex' }}>
          {
            [
              { txt: 'Less than 2 weeks ago', value: 'less_than_2_weeks' },
              { txt: '2 - 6 weeks ago', value: '1-2_months' },
              { txt: 'More than 6 weeks ago', value: '2_months_or_more' },
            ].map(({ txt, value }, index) => (<button 
                className={`btn btn-bdr last-clean-btn ${value === state?.lastClean ? "btn-warning btn-2px-border" : " "}`}
                style={{ color: "black" }}
                variant="outline"
                onClick={e => selectLastClean(value)}
                key={index}
                name="lastClean"
                disabled={transection_type === 'View'}>{txt}
              </button>))
          }
        </div>
        {errors?.['lastClean'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['lastClean']}</label> : ''}
      </React.Fragment>}
    </>
  )
}

function CleaningAreas() {

  const { state, setState, currentRecord = {}, transection_type } = useContext(PageContext);
  const { errors } = state;

  useEffect(() => {
    if (transection_type === "Update" || transection_type === "View") {
      axios.get(`/service-ftech/${currentRecord?.uuid}`)
        .then(response => {
          let claning_area = response?.data?.area_to_clean;
          let other = claning_area?.filter(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' });
          let idx = claning_area?.findIndex(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' });
          if (other && other.length > 0) {
            claning_area[idx] = '';
            setState(s => ({
              ...s,
              cleaningAreas: claning_area,
              otherCleaning: other && other.length > 0 ? other[0] : '',
              isOtherCleanArea: true
            }));
          } else {
            setState(s => ({
              ...s,
              cleaningAreas: response?.data?.area_to_clean,
              otherCleaning: '',
              isOtherCleanArea: false
            }));
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else if (transection_type === "Create") {
      let claning_area = currentRecord?.area_to_clean;
      let other = claning_area?.filter(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' });
      let idx = claning_area?.findIndex(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' });
      if (other && other.length > 0) {
        claning_area[idx] = '';
        setState(s => ({
          ...s,
          cleaningAreas: claning_area,
          otherCleaning: other && other.length > 0 ? other[0] : '',
          isOtherCleanArea: true
        }));
      } else {
        setState(s => ({
          ...s,
          cleaningAreas: claning_area,
          otherCleaning: '',
          isOtherCleanArea: false
        }));
      }            
    }
  }, [])

  const toggleArea = (area) => {
    const { cleaningAreas = [], isOtherCleanArea } = state;
    const idx = cleaningAreas.indexOf(area);
    if (idx <= -1) {
      cleaningAreas.push(area);
    } else {
      cleaningAreas.splice(idx, 1);
    }
    if (area === "") {
      setState(s => ({ ...s, isOtherCleanArea: !isOtherCleanArea }))
    }
    setState(s => ({ ...s, cleaningAreas: cleaningAreas }));
  }

  const setOtherCleaning = (value) => {
    setState(s => ({ ...s, otherCleaning: value }));
  }

  return (
    <>
      <h4 className="mb-10">Cleaning Areas <sup>*</sup></h4>
      {
        [
          'front yard',
          'back yard',
          'right side',
          'left side',
          'dog run',
          'fenced area',
          ''
        ].map((txt, index) => (
          <div className="inline-checks inline-blck" key={`areaClean${index}`}>
            <label htmlFor={txt}
              className={state.cleaningAreas.includes(txt) ? "active" : ''}
            >
              <input type="checkbox" id={txt} name={txt} className="" value={txt} onChange={(e) => toggleArea(txt)} disabled={transection_type === 'View'} />
              <span>{txt === '' ? 'Other' : txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()}</span>
            </label>
          </div>
        ))
      }
      {state?.isOtherCleanArea && <div className="from-group w-100">
        <div className="fitem">
          <input
            type="text"
            className=""
            id="bi_monthly1"
            name="bi_monthly"
            value={state?.otherCleaning}
            disabled={transection_type === 'View'}
            placeholder="Additional other areas to clean"
            onChange={(e) => { setOtherCleaning(e?.target?.value) }}
          />
        </div>
      </div>}
      {errors?.['cleaningAreas'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['cleaningAreas']}</label> : ''}
      {errors?.['otherCleaning'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['otherCleaning']}</label> : ''}
    </>
  )
}

function AddOns() {
  const { state, setState, addOns, transection_type } = useContext(PageContext);

  function toggleAddon(addon) {
    if(transection_type === "Create" || transection_type === "Update"){
      const item = state?.addons?.find(item => item === addon);
      if (!item) {
        setState(s => ({ ...s, addons: [...state?.addons, addon] }))
      } else {
        setState(s => ({ ...s, addons: [...state?.addons?.filter(item => item !== addon)] }))
      }
    }
  }
  return (
    <>
      <h4>Addons</h4>
      <div className="flex flex-wrap">
        {addOns && addOns.map((txt, index) => (
          <button
            onClick={ (e) => {
              toggleAddon(txt.uuid)
            }}
            disabled={transection_type === "View" ? true : false}
            className={`btn btn-2px-border btn-bdr flex-1 px-10 ${state.addons.includes(txt.uuid) && (transection_type === "Create" || transection_type === "Update" || transection_type === "View" ) ? "btn-warning" : transection_type === 'View' ? "btn-disabled" : ''}`}
            style={{ color: "black" }}
            key={index}>{txt.name}
          </button>))
        }
      </div>
    </>
  )
}

function Miscellanious() {

  const { state, setState, transection_type } = useContext(PageContext);
  const { errors, rows } = state;

  const setRows = () => {
    rows.push({mis_type:"", item: "", price: "" });
    setState(s => ({ ...s, rows: rows }));
  }

  const onDeleteRow = (index) => {
    rows.splice(index, 1);
    setState(s => ({ ...s, rows: rows }));
  }

  const onNumericInputChange = (value) => {
    if (value === null || value === '' || value === '-' || !isNaN(value)) {
      return true;
    }
    return false;
  };

  const onRowDataChange = (value, index, key) => {
    const rows_ = [...state.rows];
    console.log("rows_",rows_);
    rows_[index][key] = value;
    setState(s => ({ ...s, rows: rows_ }))
  }


  const renderItemRow = () => {
    return (<React.Fragment> {map(state.rows, (item, index) => {
      return (
        <div className="divrow" key={`items${index}`} style={{ marginLeft: "0px", marginBottom: "10px" }}>
          <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <Select
                disabled={transection_type === 'View'}
                showArrow
                virtual={false}
                style={{ width: '100%' }}
                value={item?.mis_type?item?.mis_type:"Select Type"}
                onChange={(e) => onRowDataChange(e,index,"mis_type")}
              >
                <Option value="product" id="product">Product</Option>
                <Option value="service" id="service">Service</Option>
              </Select>
              {errors?.[`rows[${index}].mis_type`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].mis_type`]===`rows[${index}].mis_type must be one of the following values: product, service`?"Select one":errors?.[`rows[${index}].mis_type`]}</label> : ''}
            </div>
          </div>
          <div className="dcell sprice pt-0 pr-5 pl-0">
            <div className="sprice mr-0">
              <input
                type="text"
                className="form-control"
                value={item?.item}
                name="item"
                disabled={transection_type === 'View'}
                onChange={(e) => onRowDataChange(e?.target?.value, index, "item")}
                placeholder="Item"
              />
              {errors?.[`rows[${index}].item`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].item`]}</label> : ''}
            </div>
          </div>
          <div className="dcell sprice pt-0 pl-5">
            <div className="sprice mr-0" style={{ position: 'relative' }}>
              {item?.price ? <span style={{ position: 'absolute', left: '6px', marginTop: '12px' }}>$</span> : ''}
              <input
                type="text"
                className="form-control"
                value={item?.price}
                name="price"
                disabled={transection_type === 'View'}
                onChange={(e) => onNumericInputChange(e.target.value) && onRowDataChange(e?.target?.value, index, "price")}
                placeholder="Price"
              />
              {errors?.[`rows[${index}].price`] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.[`rows[${index}].price`]}</label> : ''}
            </div>
          </div>
          { transection_type !== "View" ? <CloseOutlined style={{ marginTop: "23px" }} onClick={() => onDeleteRow(index)}></CloseOutlined> : null }
        </div>
      )
    })}</React.Fragment>)
  }

  return (
    <>
      <h4 className="mb-8">Miscellaneous</h4>
      {renderItemRow()}
      {
        transection_type !== "View" ?
          <a
            href="/#"
            className={`addmore-btn}`}
            onClick={(e) => { 
              e.preventDefault(); 
              setRows((arr) => [...rows, {mis_type: "", item: "", price: "" }]);
            }}>
            <img src={addGreenCircle} alt="" style={{ marginRight: '6px' }} />
              Add Item
          </a> : null
      }
    </>
  )
}

function WorkOrderSummary(props) {
  const ctx = useContext(PageContext);
  const { price } = ctx;
  const amount = num => (Math.round(num * 100) / 100).toFixed(2);

  const setSubscription = (frequency) => {
    switch (frequency) {
    case 'twice_weekly':
      return "Twice Weekly"
    case 'weekly':
      return "Weekly"
    case 'bi_monthly':
      return "Every Other Week"
    case 'monthly':
      return "Monthly"
    case 'once':
      return "One-Time"
    default:
            // console.warn('Default Case');
    }
  }

  const setLastClean = (lastClean) => {
    switch (lastClean) {
    case 'less_than_2_weeks':
      return "Less than 2 weeks"
    case '1-2_months':
      return "2-6 weeks"
    case '2_months_or_more':
      return "More than 6 weeks Ago"
    default:
            // console.warn('Default Case');
    }
  }

  const setCleaningAreas = (cleaningArea) => {
    switch (cleaningArea) {
    case 'front yard':
      return "Front Yard"
    case 'back yard':
      return "Back Yard"
    case 'right side':
      return "Right Side"
    case 'left side':
      return "Left Side"
    case 'dog run':
      return "Dog Run"
    case 'fenced area':
      return "Fenced Area"
    case '':
      return "Other"
    default:
            // console.warn('Default Case');
    }
  }

  return (
    <div style={{ background: "white", padding: "25px 30px" }}>
      <h2 className="mb-20">Work Order Summary</h2>
      <h5 className="mb-10">
        <b>Subscription details</b>
      </h5>
      <div>
        <div className="fs-13 mb-10">
          <div className="summary-label">Subscription</div>
          <div className="flex summary-detail">
            <span>{  setSubscription(price?.frequency)} service, {price?.pet_count} dog{price?.pet_count > 1 && "s"}</span>
            <span>${formatToCurrency(amount(price?.service_base_price))}</span>
          </div>
        </div>

        {price?.one_time_charges?.one_time_items?.length > 0 && <div className="fs-13 mb-10">
          <div className="summary-label">Last Clean</div>
          {price?.one_time_charges?.one_time_items?.map((item, index) => <div key={index} className="flex summary-detail">
            <span>{setLastClean(item?.name)}</span>
            <span>${formatToCurrency(amount(item?.price))}</span>
          </div>)}
        </div>}

        {price?.cleaning_areas?.items?.length > 0 && <div className="fs-13 mb-10">
          <div className="summary-label">Cleaning Areas</div>
          {price?.cleaning_areas?.items?.map((item, index) => <div key={index} className="flex summary-detail">
            <span>{setCleaningAreas(item?.area)}</span>
            <span>${formatToCurrency(amount(item?.price))}</span>
          </div>)}
        </div>}
        {price?.add_ons?.recurring_addon_items?.length > 0 && <div className="fs-13 mb-10">
          <div className="summary-label">Addons</div>
          {price?.add_ons?.recurring_addon_items?.map((item, index) => (
            <div className="flex summary-detail" key={index}>
              <span>{item?.name}</span>
              <span>${formatToCurrency(amount(item?.price))}</span>
            </div>
          ))}
        </div>}

        {price?.miscallaneous_services?.length > 0 && <div className="fs-13 mb-10">
          <div className="summary-label">Miscellaneous</div>
          {price?.miscallaneous_services?.map((item, index) => (
            <div className="flex summary-detail" key={index}>
              <span className='text-capitalize'>{item?.mis_type}</span>
              <span className='text-capitalize'>{item?.item}</span>
              <span>${formatToCurrency(amount(item?.price))}</span>
            </div>
          ))}
        </div>}
      </div>
      <div className="flex summary-total">
        <span>Total to Pay (excl. tax)</span>
        <span>${formatToCurrency(amount(price?.total_price_per_service))}</span>
      </div>
    </div>
  )
}